export enum RoadTypes {
  CCRoad = 1,
  BTRoad = 2,
  InterlockingTile = 3,
  KankarRoad = 4,
  KatchRoad = 5,
}
